import { Component } from "react";
import { Link } from "react-router-dom";

/** Catches render crashes so the dark empty #root shell is not the only signal. */
export default class AppErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error) {
    // eslint-disable-next-line no-console
    console.error("YUG360 UI crash", error);
  }

  render() {
    if (!this.state.error) return this.props.children;
    return (
      <main className="login-screen login-screen-auth" data-testid="app-error-boundary">
        <section className="login-hero">
          <p className="kicker">WORKSPACE ERROR</p>
          <h1>Something broke in the UI.</h1>
          <p className="muted">The API may still be healthy. Reload, or sign in again and reopen the application.</p>
          <div className="landing-hero-ctas">
            <button type="button" className="primary-button" onClick={() => window.location.assign("/")}>
              Reload home
            </button>
            <Link className="secondary-button" to="/login">Sign in</Link>
          </div>
        </section>
      </main>
    );
  }
}
